import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const types = ["1v1", "multiple"];
const multiColors = [
    "multi",
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.DARK_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
];
const singleColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.LIGHT_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.LIGHT_YELLOW,
];
export const PollOverlay = defineOverlay({
    defaults: {
        multiBackgroundColor: "multi",
        showDollars: true,
        showPercentage: true,
        singleBackgroundColor: Color.DEFAULT_RED,
        type: "1v1",
    },
    details: {
        category: "overlays",
        description: "Utilize one of our two dynamic poll overlays to track voting results from your Tiltify fundraising campaign. Easily display live results from a head-to-head voting battle or a list of voting options on your stream.",
        features: [
            "Head-to-Head poll option",
            "Poll for multiple options",
            "Poll name displays every 5 minutes",
            "Live vote tracking",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/poll.png",
        name: "Polls Overlay",
        obsDimensions: [
            { height: "70px", width: "1920px" },
            { height: "preferred size", width: "preferred size" },
        ],
        path: "/overlays/polls",
        shortDescription: "Display live results from your Tiltify poll on your stream.",
        slug: "polls",
    },
    schema: BaseOverlayConfig.extend({
        multiBackgroundColor: z
            .enum(multiColors)
            .default(() => PollOverlay._config.defaults.multiBackgroundColor)
            .optional(),
        showDollars: z
            .boolean()
            .default(() => PollOverlay._config.defaults.showDollars)
            .optional(),
        showPercentage: z
            .boolean()
            .default(() => PollOverlay._config.defaults.showPercentage)
            .optional(),
        singleBackgroundColor: z
            .enum(singleColors)
            .default(() => PollOverlay._config.defaults.singleBackgroundColor)
            .optional(),
        type: z
            .enum(types)
            .default(() => PollOverlay._config.defaults.type)
            .optional(),
    }),
});
//# sourceMappingURL=poll.js.map